import React from 'react';

export default class ComplicationRating extends React.Component {

  render() {

    return (
         <div>
            <h5><b>{this.props.rating.FriendlyDescription}</b></h5>
            <p>{this.props.rating.Rating}</p>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/ComplicationRating.js